<template>
<div class="mt-8 text-center">
  <h1 class="errorPageTitle mb-0">403</h1>
  <p class="errorPageSubTitle">Forbidden</p>
  <p>現在ログインしているアカウント、もしくはログインしようとしているアカウントには
    この管理画面へのアクセス権限がありません。<br>
    管理者から権限を付与してもらうか、一度ログアウトした後、権限のある他のアカウントにて再度ログインしてください。
  </p>
  <LogoutBtn />
</div>
</template>
<script>
import LogoutBtn from '../../../container/shared/LogoutBtn'

export default ({
  name: 'Forbidden',
  components: {
    LogoutBtn
  }
})
</script>

<style scoped>
.errorPageTitle {
  font-size: 5rem;
  font-weight: 600;
  letter-spacing: 5px;
}
.errorPageSubTitle {
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 2px;
  line-height: 2;
}
</style>
